import { SortPipe } from '../../../../../../_helpers/_pipes/sort.pipe';
import { DetailsSidebarComponent } from '../details-sidebar/details-sidebar.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { TooltipComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/tooltip/tooltip.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import { MileageService } from './../../../../../../_services/my-insurance/mileage.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';
import { Router , RouterModule } from '@angular/router';
import { MileageDataService } from '../../../../../../_services/data-services/mileage-data.service';
import { AgentNotificationService } from '../../../../../../_services/agent/agent-notification.service';
import { IdCardService } from '@services/id-card.service';
import { CompanyService } from '@services/my-insurance/company.service';
import { HomeHeaderComponent } from '@loggedin-content/my-insurance/myinsurance-headers/home-header/home-header.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslatePipe, MapfreDesignLibraryModule, NgSelectModule, TooltipComponent, MapfreButtonComponent, DetailsSidebarComponent, SortPipe, HomeHeaderComponent],
  selector: 'app-details-car',
  templateUrl: './details-car.component.html',
  styleUrls: ['./details-car.component.scss'],
})
export class DetailsCarComponent implements OnInit {
  @Output() showMileageToast: EventEmitter<any> = new EventEmitter<any>();
  @Output() showToast: EventEmitter<any> = new EventEmitter<any>();
  @Input() policy: any;
  @Input() policyIdInput: any;
  allNotElibile = false;
  buttonLoading = false;
  errorClass: any = [];
  errorMessageClass: boolean;
  errorMessage: any = [];
  loading = false;
  legalCheckbox = false;
  showMessage = false;
  setFadeBoolAlert = false;
  setFadeBoolButton = true;
  successMessage = false;
  updateMileage: FormGroup;
  mileageArray: any = [];
  isBtnEnabled = false;
  untouched = true;
  loader = false;
  alertLoad: any;
  isAcmic: boolean;
  showCompany: string;

  constructor(
    private mileageService: MileageService,
    private storageService: StorageServiceObservablesService,
    private alertService: AlertService,
    private errorRedirectionService: ErrorRedirectionService,
    private router: Router,
    private mileageDataService: MileageDataService,
    private acmicService: AcmicService,
    private agentNotification: AgentNotificationService,
    private idCardService: IdCardService,
    private companyService: CompanyService
  ) {
    this.detectStateCode();
  }

  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  createUpdateMilageFormControls(data): void {
    const milageControl = [];
    for (let i = 0; i <= data.vehicle.length; i++) {
      if (i != data.vehicle.length) {
        milageControl.push({
          name: `updateMileageInput_${i}`,
          control: new FormControl(null, [
            Validators.pattern('^[0-9]*$|^$'),
            Validators.max(1000000),
          ]),
        });
      }
    }

    const formGroup: FormGroup = new FormGroup({}),
      legalGroup: FormGroup = new FormGroup({});
    legalGroup.addControl('legalCheckMark', new FormControl(null, []));

    milageControl.forEach((f) => formGroup.addControl(f.name, f.control));
    this.updateMileage = new FormGroup({
      groups: formGroup,
      legal: legalGroup,
    });
  }

  checkIfAllVehiclesAreNotEligible(policy) {
    const vehicleOb = policy.vehicle;

    const allNotElibile = vehicleOb.every((v) => {
      if (v.vehicleIdentificationNumber.Id === '') {
        return true;
      }
    });

    this.allNotElibile = allNotElibile;
  }

  checkIfIndexIsTheSame(arrayIndex, index): boolean {
    if (arrayIndex == 'Please enter a value less than 1000000.') {
      const indexes = [];
      let i = -1;
      while ((i = this.errorMessage.indexOf(arrayIndex, i + 1)) != -1) {
        indexes.push(i);
      }
      return indexes.includes(index);
    } else {
      if (this.errorMessage.indexOf(arrayIndex) == index) {
        return true;
      } else {
        return false;
      }
    }
  }

  getLegalCheckBoxValue(e): void {
    if (e.target.checked) {
      this.legalCheckbox = true;
    } else {
      this.legalCheckbox = false;
    }
  }

  checkMileageValue(value, index) {
    this.errorMessageClass = false;
    if (value != '') {
      this.mileageArray[index] = value;
      this.errorMessage = [];
      for (let i = 0; i < this.mileageArray.length; i++) {
        if (this.mileageArray[i] >= 1000000) {
          this.errorMessage[i] = 'MILEAGE_MAX_LIMIT';
        } else {
          this.errorMessage.splice(i, 1);
          this.isBtnEnabled = true;
        }
      }
    } else {
      this.isBtnEnabled = true;
    }
  }

  onSubmit(vin, mileage, vehicle, index): void {
    this.agentNotification.setHeader(this.policy);
    const policyId = this.policyIdInput,
      form = this.updateMileage,
      email = this.storageService.getUserFromStorage();

    this.mileageDataService.updatemileage({
      vin,
      mileage,
      vehicle,
      policyNumber: this.policyIdInput,
    });
    this.router.navigate([
      'my-insurance',
      this.policyIdInput,
      index,
      'updatemileage',
    ]);

    if (
      this.legalCheckbox &&
      this.updateMileage.valid &&
      this.isBtnEnabled &&
      !this.updateMileage.pristine &&
      !this.loader
    ) {
      if (
        (this.policy &&
          this.policy['days_left_to_expire'] &&
          this.policy['days_left_to_expire'] <= 30 &&
          this.policy.policynumber.policyNumber.length === 6 &&
          this.policy.livoPolicy) ||
        this.policy['isNewPolicy']
      ) {
        this.showMessage = true;
        this.showMileageToast.emit(true);
        this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      } else {
        this.updateMileageById(policyId, form, email);
      }
    }
  }

  loadingButtonAndAlert(): void {
    this.buttonLoading = false;
    if (this.successMessage === true) {
      this.setFadeBoolButton = false;
      setTimeout(() => {
        this.showMessage = true;
        setTimeout(() => {
          this.setFadeBoolAlert = true;
          setTimeout(() => {
            this.setFadeBoolAlert = false;
            setTimeout(() => {
              this.showMessage = false;
              this.setFadeBoolButton = true;
              this.successMessage = false;
            }, 250);
          }, 2000);
        }, 250);
      }, 250);
    }
  }

  validateMileage(inputValue, arrayValue, i) {
    inputValue.value =
      typeof inputValue.value == 'string'
        ? Number(inputValue.value)
        : inputValue.value;
    if (inputValue.value !== '' && inputValue.dirty) {
      this.untouched = false;
      if (inputValue.value > arrayValue) {
        this.errorMessage[i] = '';
        this.errorClass[i] = false;
        return true;
      } else if (inputValue.value < arrayValue) {
        this.errorMessage[i] = 'VALUE_LESS_THAN_ORIGINAL';
        this.errorClass[i] = true;
        this.errorMessageClass = true;
        return false;
      }
    }
    return true;
  }

  updateMileageById(policyId, form, email) {
    if (this.loader) {
      return false;
    }
    this.buttonLoading = true;
    const successArray = [];
    let validate = true;
    // make sure that all of the arraies clear out. The is no reason to add values on a new
    // instantiante of the method, aka when someone reclicks the confirm button.

    this.errorMessage.length = 0;
    successArray.length = 0;
    this.errorClass.length = 0;

    this.policy.vehicle.forEach((vehicleDetail, i) => {
      const formController = form.controls.groups,
        odometerReading =
          vehicleDetail.odometerReading && vehicleDetail.odometerReading != 0
            ? vehicleDetail.odometerReading.toString()
            : '';
      validate =
        validate &&
        this.validateMileage(
          formController.controls[`updateMileageInput_${i}`],
          odometerReading,
          i
        );
    });
    if (this.untouched) {
      this.policy.vehicle.forEach((vehicleDetail, i) => {
        this.errorMessage[i] = 'PLEASE_UPDATE_MILEAGE';
        this.errorClass[i] = true;
        this.errorMessageClass = true;
      });
    } else if (validate) {
      this.loader = true;
      const formController = form.controls.groups;
      const odometerReadingData = [];
      this.policy.vehicle.forEach((vehicleData, i) => {
        if (!formController.controls[`updateMileageInput_${i}`].pristine) {
          odometerReadingData.push({
            Id: vehicleData.vehicleIdentificationNumber.Id || '',
            odoMeterReading:
              formController.controls[`updateMileageInput_${i}`].value ||
              vehicleData.odometerReading,
          });
          formController.controls[`updateMileageInput_${i}`].markAsPristine();
        }
      });

      this.mileageService
        .updateMileage(email, policyId, odometerReadingData)
        .subscribe(
          () => {
            for (let i = 0; i < this.policy.vehicle.length; i++) {
              if (
                !formController.controls[`updateMileageInput_${i}`].pristine
              ) {
                this.policy.vehicle[i].odometerReading =
                  formController.controls[`updateMileageInput_${i}`].value;
              }            
            }
            this.loader = false;
            this.showMessage = true;
            if (policyId.length === 10) {
              this.alertService.success(
                'Your request has been sent to the company for processing.'
              );
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            } else {
              this.alertService.success('THANKS_FOR_UPDATING_YOUR_ODOMETER');
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }
            this.showMileageToast.emit(true);
            this.untouched = true;
            this.errorClass.fill(false);
            this.errorMessage.fill('');
            setTimeout(() => {
              this.showMessage = false;
              this.updateMileage
                .get('legal')
                ['controls']['legalCheckMark'].setValue(false);
            }, 2000);
          },
          (error) => {
            this.loader = false;
            if (
              error.status === 400 ||
              error.status === 401 ||
              error.status === 403 ||
              error.status === 404 ||
              error.status === 408
            ) {
              this.errorClass.fill(true);
              this.errorMessageClass = true;
              this.errorMessage.fill('PROBLEM_UPDATING_MILEAGE');
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            } else {
              this.errorRedirectionService.redirect(error.status);
            }
          }
        )

        .add(() => {
          this.loadingButtonAndAlert();
        });
    }
  }

  getIdCardDocument(vehicle, action) {
    this.idCardService.getIdCard(this.policy, action, this.policy.policynumber.policyNumber, [vehicle]);
  }
  ngOnInit() {
    this.checkIfAllVehiclesAreNotEligible(this.policy);
    this.createUpdateMilageFormControls(this.policy);
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    });
  }
}
